import { Injectable, EventEmitter } from '@angular/core';

export interface IRouteErrors {
    route: string;
    error: string;
    errors: any;
    validationErrors: string[];
}

@Injectable()
export class ModelStateValidationService {
    errors: IRouteErrors[];
    modelStateValidationChanged: EventEmitter<IRouteErrors> = new EventEmitter();

    constructor() {
        this.errors = [];
    }

    getErrors(route: string): IRouteErrors {
        let errors = this.errors.find(e => e.route === route);
        if (!errors) {
            errors = ({ route: route, errors: [], validationErrors: [] } as IRouteErrors);
        }
        return errors;
    }

    setErrors(handler: IRouteErrors) {
        const index = this.errors.findIndex(e => e.route === handler.route);
        if (index >= 0) {
            this.errors[index] = handler;
        } else {
            this.errors.push(handler);
        }
        this.modelStateValidationChanged.emit(handler);
    }

    setModelStateErrors(response: Response): IRouteErrors {
        const routeErrors = this.getModelStateErrors(response);
        if (routeErrors) {
            this.setErrors(routeErrors);
        }
        return routeErrors;
    }

	getModelStateErrors(response: any): IRouteErrors {

		try {

			const errorJson = response.json();
			if (errorJson) {
				return {
					route: response.url,
					error: errorJson.message
						? errorJson.message
						: errorJson.error_description
						? errorJson.error_description
						: response.statusText,
					errors: errorJson,
					validationErrors: this.getValidationErrors(errorJson)
				};
			}

			return null;


		} catch (e) {
			return null;
		}

        
    }

    getValidationErrors(errors: any): string[] {
        const items: string[] = [];
        for (let prop in errors) {
            const obj = errors[prop];
            if (Array.isArray(obj)) {
                for (let value of obj) {
                    items.push(`${prop}: ${value}`);
                }
            } else {
                items.push(prop);
            }
        }
        return items;
    }

    handleError(error: any) : void {
        const routeErrors = this.setModelStateErrors(error);
        error.routeErrors = routeErrors;
        const { validationErrors } = routeErrors;
        if (validationErrors.length > 0) {
            throw validationErrors.join("\n");    
        }
        throw error;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/model-state-validation.service.ts